import { useEffect, useRef, useState } from "react";
import actions from "../../actions/actions";
import { useUpdateState } from "../../utilities/utilities";
import Card from "../../components/card";
import MessageDropdown from "../MessageDropdown";
import { Tooltip } from "react-bootstrap";
import PageLayout from "../../components/page-layout";
import user from "../../actions/user-actions";
import "../../styles/messages.scss";
import Grid from "../../components/grid";
import { GuiCheckbox } from "../../components/global-ui/gui-checkbox";
import { GuiButton } from "../../components/global-ui/gui-button";
import { GuiTooltip } from "../../components/global-ui/gui-tooltip";
import AudioPlayer from "../../components/audio-player";
import CircularProgress from "../../actions/CircularProgress";
import MessageTabs from "./MessageTabs";
import { Modal } from "../../components/modal";
import api from "../../api/api";
import { showToast } from "../../components/toast";
import SliderSearchBox from "../../components/slider-search-box";
import { useSelector } from "react-redux";
import { formatDateISO } from "../../utilities/utilities";
import BottomNavBar from "../BottomNavBar";
import {
  removeTags,
  useIsDesktop,
  DISCARD_ROUTES,
  UserRole,
} from "../../utilities/constants";
import Popover from "../../components/popover";
import navigate from "../../utilities/navigation";
import { Path } from "../../utilities/constants";
import { appState, dispatch as reduxDispatch } from "../../redux/redux-config";
import {
  TABS,
  tabToStatus,
  formattedDate,
  getInitials,
  alertTypeName,
  alertIcon,
  formatDescription,
} from "../../utilities/messages-helpers";

let noResultsToastShown = false;
export default function Messages(props) {
  const userId = props.match && props.match.params && props.match.params.id;
  const personName = JSON.parse(localStorage.getItem("selectedPerson"));
  let alert = useSelector((store) => store.alert.current);
  const [groupList, setGroupList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [alertTypes, setAlertTypes] = useState([]);
  let [state, updateState] = useUpdateState(() => {
    const saved = appState().message.savedFilter;
    return {
      messageList: [],
      groupList: [],
      createdUserList: [],
      advanceFilter: saved?.advanceFilter || {},
      filterPills: saved?.filterPills || [],
      selectedFilter: saved?.selectedFilter || undefined,
      totalCount: 0,
      scheduledCount: 0,
      totalCredits: "",
      remainingCredits: "",
      billingCycle: "Monthly",
      emailTotalCredits: "",
      emailRemainingCredits: "",
      emailBillingCycle: "Monthly",
      gridReset: 0,
      isDeleteEnabled: false,
      showDeleteModal: false,
      isLoading: false,
      selectedMsg: 0,
      search: saved?.search || "",
      alertType: [
        { value: 0, label: "All" },
        { value: 1, label: "Voice" },
        { value: 2, label: "Email" },
        { value: 3, label: "SMS" },
        { value: 4, label: "VoiceIVR" },
        { value: 7, label: "RSS" },
      ],
    };
  });
  const [isOpen, setIsOpen] = useState(false);
  const [audioUrls, setAudioUrls] = useState({});
  const [isDraftMode, setIsDraftMode] = useState(false);
  let [checkboxState, updateCheckboxState, setCheckboxState] = useUpdateState(
    {},
  );

  // Get current user for role-based access control
  const currentUser = useSelector((store) => store.user);
  const loginUserType = currentUser?.userType;
  const [selectedTab, setSelectedTab] = useState(() => {
    const saved = appState().message.savedFilter;
    return saved?.selectedTab || "all";
  });
  let isMobile = useSelector((store) => store.page.isMobile);

  const tabs = TABS;
  const messageRef = useRef(null);
  const handleOutsideClick = (event) => {
    if (messageRef.current && !messageRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  function setSearch(search) {
    updateState({ search: search, gridReset: state.gridReset + 1 });
  }

  useEffect(() => {
    if (isDraftMode && alert && alert.id) {
      actions.alerts.showEditAlert(alert, DISCARD_ROUTES.messages);
      setIsDraftMode(false); // reset flag
    }
  }, [alert, isDraftMode]);

  async function handleAsDraft(alertId) {
    setIsDraftMode(true);
    await actions.alerts.loadAlertDetails(alertId);
  }

  function handleAsEdit(alertId) {
    actions.alerts.loadAlertDetails(alertId);
    actions.alerts.showEditAlert(alert, DISCARD_ROUTES.messages);
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }

    // Cleanup event listener when component unmounts
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [isOpen]);
  const getSelectedCheckboxes = () => {
    const selectedCheckboxes = Object.entries(checkboxState)
      .filter(([key, value]) => value)
      .map(([key]) => {
        let [groupId, alertId] = key.split("_");
        const message = state.messageList.find((msg) => {
          return (
            msg.id === parseInt(alertId) && msg.groupId === parseInt(groupId)
          );
        });

        return message;
      });
    const filteredCheckboxes = selectedCheckboxes
      .filter((item) => item.status === 3 || item.status === 2)
      .map((items) =>
        (({ id, groupId }) => ({
          alertId: id,
          groupId: groupId,
        }))(items),
      );
    const totalSelected = selectedCheckboxes?.length;
    updateState({
      isDeleteEnabled: filteredCheckboxes?.length > 0,
      filteredCheckboxes: filteredCheckboxes,
      selectedMsg: totalSelected,
    });
    return filteredCheckboxes;
  };
  const handleTabChange = (tabId) => {
    setSelectedTab(tabId);
    updateState({ gridReset: state?.gridReset + 1 });
    setCheckboxState({});
    updateState({ selectedMsg: 0, isDeleteEnabled: false });
  };
  useEffect(() => {
    getSelectedCheckboxes();
  }, [checkboxState]);

  useEffect(() => {
    if (loginUserType !== UserRole.Member) {
      getAlertCredit();
      getEmailCredit();
    }

    if (isOpen) {
      const tooltip = document.querySelector(
        ".dashboard-mobile-tooltip .gui-tooltip",
      );
      const icon = document.querySelector(".mobile-title-progress-icon");
      if (!tooltip || !icon) return;

      const iconRect = icon.getBoundingClientRect();
      const left = iconRect.left + iconRect.width / 2 - tooltip.offsetWidth / 2;
      const clampedLeft = Math.max(
        8,
        Math.min(left, window.innerWidth - tooltip.offsetWidth - 8),
      );

      tooltip.style.top = `${iconRect.bottom}px`;
      tooltip.style.left = `${clampedLeft}px`;
    }
  }, [isOpen]);

  async function getAlertCredit() {
    let result = await user.getAlertCredit();
    if (result?.success) {
      updateState({
        totalCredits: result?.totalCredits,
        remainingCredits: result?.remainingCredits,
        billingCycle: result?.billingCycle,
      });
      return result;
    }
  }

  async function getEmailCredit() {
    let result = await user.getEmailCredit();
    if (result?.success) {
      updateState({
        emailTotalCredits: result?.totalCredits,
        emailRemainingCredits: result?.remainingCredits,
        emailBillingCycle: result?.billingCycle,
      });
      return result;
    }
  }

  async function convertTTS(description) {
    const result = await actions.alerts.textToSpeech(description);
    return result;
  }

  // Get tridot menu role wise
  function getMenuOptionsForStatus(status, message) {
    // Role-based delete option logic
    if (loginUserType === UserRole.Member) {
      // Student: never show delete
      switch (status) {
        case 1:
          return selectedTab === "sent"
            ? ["Use as Draft", "View Details"]
            : ["Use as Draft"];
        case 4:
          return [];
        case 2:
          return ["Send Now", "Edit"];
        case 3:
          return ["Edit"];
        default:
          return [];
      }
    } else if (loginUserType === UserRole.Admin) {
      // Admin: always show delete
      switch (status) {
        case 1:
          return selectedTab === "sent"
            ? ["Use as Draft", "View Details"]
            : ["Use as Draft"];
        case 4:
          return ["Delete"];
        case 2:
          return ["Delete", "Send Now", "Edit"];
        case 3:
          return ["Delete", "Edit"];
        default:
          return [];
      }
    } else if (loginUserType === UserRole.Staff) {
      // Staff: show delete only for own messages
      const isOwnMessage = message?.createdUserId === currentUser?.userId;
      switch (status) {
        case 1:
          return selectedTab === "sent"
            ? ["Use as Draft", "View Details"]
            : ["Use as Draft"];
        case 4:
          return [];
        case 2:
          return isOwnMessage
            ? ["Delete", "Send Now", "Edit"]
            : ["Send Now", "Edit"];
        case 3:
          return isOwnMessage ? ["Delete", "Edit"] : ["Edit"];
        default:
          return [];
      }
    } else {
      // Default fallback
      return [];
    }
  }
  function handleTridotAction(action, message) {
    switch (action) {
      case "Delete":
        updateState({
          showDeleteModal: true,
          singleEntryDelete: true,
          singleEntryId: [{ alertId: message?.id, groupId: message?.groupId }],
          selectedMsg: 1,
          isDeleteEnabled: true,
        });
        break;
      case "Edit":
        handleAsEdit(message?.id);
        break;
      case "Send Now":
        handleAsEdit(message?.id);
        break;
      case "Use as Draft":
        handleAsDraft(message?.id);
        break;
      case "View Details":
        onMsgClick(message?.id);
        break;
      default:
        break;
    }
  }

  function renderStatusBadge(status, isMobileBadge = false) {
    if (status === 2) {
      return (
        <GuiButton
          className={
            isMobileBadge
              ? "mobile-scheduled-alert-type-btn"
              : "scheduled-alert-type-btn"
          }
        >
          <span>
            <i className="fa fa-clock"></i>
            {!isMobileBadge && "Scheduled"}
          </span>
        </GuiButton>
      );
    }

    if (status === 3) {
      return (
        <GuiButton
          className={
            isMobileBadge
              ? "mobile-draft-alert-type-btn"
              : "draft-alert-type-btn"
          }
        >
          <span>
            <i className="fa fa-pen"></i>
            {!isMobileBadge && "Draft"}
          </span>
        </GuiButton>
      );
    }

    if (status === 5) {
      return (
        <GuiButton
          className={
            isMobileBadge
              ? "mobile-preparing-alert-type-btn"
              : "preparing-alert-type-btn"
          }
        >
          <span>
            <i className="fa fa-spinner"></i>
            Preparing
          </span>
        </GuiButton>
      );
    }

    return null;
  }

  async function loadRows(
    page,
    pageSize,
    skipTotal,
    tabId = selectedTab,
    advanceFilter = state?.advanceFilter,
  ) {
    updateState({ isLoading: true });
    let search = state?.search ? state?.search.trim() : "";

    let payload = {
      status: tabToStatus(tabId),
      pageNum: page,
      pageSize: pageSize,
      search: search,
      advanceFilters: advanceFilter,
      sort: [],
      skipTotal: skipTotal,
    };

    let result;
    try {
      result = await actions.messages.loadMessages(payload, userId);
    } catch (error) {
      console.error("Failed to load messages:", error);
      showToast("error", "Unable to load messages");
    }
    const list = Array.isArray(result?.list) ? result.list : [];
    const totalCount =
      typeof result?.totalCount === "number"
        ? result.totalCount
        : (state?.totalCount ?? 0);
    const scheduledCount =
      typeof result?.scheduledCount === "number"
        ? result.scheduledCount
        : (state?.scheduledCount ?? 0);

    list.forEach((message) => {
      if (message?.alertType === 1) {
        if (message?.voiceFileUrl) {
          setAudioUrls((prev) => ({
            ...prev,
            [message?.id]: message?.voiceFileUrl,
          }));
        } else {
          convertVoice(message?.messageBody, message?.id);
        }
      }
    });

    if (result?.success) {
      updateState({
        totalCount: result?.totalCount,
        scheduledCount: result?.scheduledCount,
        messageList: result?.list,
        latestPage: result?.list,
        createdUserList: result?.createdUserList ?? state?.createdUserList,
        groupList: result?.groupList ?? state?.groupList,
        isLoading: false,
      });
    }

    if (
      result?.list?.length === 0 &&
      page === 1 &&
      !skipTotal &&
      !noResultsToastShown
    ) {
      showToast("error", "No results found");
      noResultsToastShown = true;
      setTimeout(() => {
        noResultsToastShown = false;
      }, 10000); // Reset after 10s
    } else {
      noResultsToastShown = false; // Reset if results found
    }

    updateState({ isLoading: false });

    return {
      ...(result || {}),
      list,
      totalCount,
      scheduledCount,
    };
  }
  function onPageChanged(list) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setCheckboxState({});
    updateState({ currentPage: list });
  }
  // formattedDate, alertTypeName, alertIcon, formatDescription now imported

  async function convertVoice(messageBody, messageId) {
    try {
      const response = await convertTTS(messageBody);
      if (response.success) {
        setAudioUrls((prev) => ({
          ...prev,
          [messageId]: response?.fileUrl,
        }));
      } else {
        console.error("TTS conversion failed:", response.error);
      }
    } catch (error) {
      console.error("Error during TTS conversion:", error);
    }
  }

  async function handleDelete() {
    updateState({
      isLoading: true,
    });
    let payload = state.singleEntryDelete
      ? state.singleEntryId
      : state.filteredCheckboxes;

    let response = await api.messages.bulkDelete(payload);
    if (response?.success) {
      showToast("success", response?.message);
    } else {
      showToast("error", response.message);
    }

    updateState({
      gridReset: state.gridReset + 1,
      showDeleteModal: false,
      isLoading: false,
      singleEntryDelete: false,
      singleEntryId: [],
      selectedMsg: 0,
      isDeleteEnabled: false,
    });
    setCheckboxState({});
  }

  useEffect(() => {
    loadMessages();
  }, [selectedTab]);

  const loadMessages = async () => {
    let payload = {
      status:
        selectedTab === "all"
          ? 0
          : selectedTab === "sent"
            ? 1
            : selectedTab === "received"
              ? 4
              : selectedTab === "scheduled"
                ? 2
                : 3,
      pageNum: 1,
      pageSize: 20,
      search: "",
      advanceFilters: state.advanceFilter,
      sort: [],
      skipTotal: false,
    };

    let result = await actions.messages.loadMessages(payload, userId);
    if (result && result?.success) {
      updateState({
        totalCount: result?.totalCount,
        scheduledCount: result?.scheduledCount,
        messageList: result?.list,
        latestPage: result?.list,
        createdUserList: result?.createdUserList,
        groupList: result?.groupList,
        isLoading: false,
      });
      setGroupList(result?.groupList);
      setUserList(result?.createdUserList);
      setAlertTypes(state?.alertType);
    }
  };

  function applyFilter(advanceFilter) {
    // When the user explicitly clears all filters, discard the persisted state
    if (Object.keys(advanceFilter).length === 0) {
      reduxDispatch("MESSAGES_FILTER_CLEARED");
    }
    updateState({
      advanceFilter: advanceFilter,
      gridReset: state.gridReset + 1,
      selectedFilter: advanceFilter,
    });

    const newArray = [];
    let selectedGroup = groupList?.filter(
      (items) => items?.groupId === advanceFilter?.groupId,
    );
    let selectedUser = userList?.find(
      (item) => item?.createdUserId === advanceFilter?.senderId,
    );
    let selectedMessageType = alertTypes?.find(
      (item) => item?.value === advanceFilter?.messageType,
    );
    const filterActions = {
      dateRange: () => {
        if (advanceFilter?.startDate && advanceFilter?.endDate) {
          newArray.push({
            Date: `${formatDateISO(advanceFilter?.startDate)}-${formatDateISO(
              advanceFilter?.endDate,
            )}`,
          });
        }
      },
      messageType: () => {
        if (advanceFilter?.messageType) {
          newArray.push({ "Message Type": selectedMessageType?.label });
        }
      },
      group: () => {
        if (advanceFilter?.groupId) {
          newArray.push({
            Group: selectedGroup[0]?.groupName,
          });
        }
      },
      sender: () => {
        if (advanceFilter?.senderId) {
          newArray.push({
            From: selectedUser?.createdUserName,
          });
        }
      },
    };
    Object.keys(filterActions).forEach((key) => {
      filterActions[key]();
    });
    updateState({ filterPills: newArray });
  }
  const onMsgClick = (id) => {
    // Persist current filter/search state so it can be restored when coming back
    reduxDispatch("MESSAGES_FILTER_SAVED", {
      search: state.search,
      advanceFilter: state.advanceFilter,
      selectedFilter: state.selectedFilter,
      filterPills: state.filterPills,
      selectedTab,
    });
    const msg = state.messageList.find((m) => m.id === id);
    if (msg && msg.categoryName === "SMS Inbound") {
      localStorage.setItem("smsInboundDetails", JSON.stringify(msg));
    }
    actions.alerts.showDetails(id);
  };

  const handleIconClick = (key) => {
    const keyMapping = {
      "Message Type": ["messageType"],
      Date: ["startDate", "endDate"],
      Group: ["groupId"],
      From: ["senderId"],
    };

    // Function to update values based on provided key
    const updateObjectByKey = (displayKey, obj) => {
      const keysToNullify = keyMapping[displayKey]; // Get the actual object key(s)

      if (keysToNullify) {
        let updatedObj = { ...obj };
        keysToNullify.forEach((key) => {
          if (updatedObj.hasOwnProperty(key)) {
            updatedObj[key] = null;
          }
        });
        return updatedObj;
      }

      return obj; // Return the object as is if the key doesn't exist
    };

    let filteredObject = updateObjectByKey(key, state.advanceFilter);
    applyFilter(filteredObject);
  };
  const isBulkActionTab =
    selectedTab === "scheduled" || selectedTab === "drafts";
  return (
    <>
      <div className="page-layout-message">
        <PageLayout
          title={userId ? `${personName?.name}'s Messages` : "Messages"}
          creditAlert={userId ? null : state}
          backButton={!!userId}
          onBackClick={() =>
            navigate(Path.PeopleDashboard.replace(":id", userId))
          }
          backButtonLabel={"Back to " + personName?.name + "'s Dashboard"}
          buttonBar={
            <div className="mobile-title">
              {loginUserType !== UserRole.Member && isMobile && (
                <>
                  <div
                    ref={messageRef}
                    className={`mobile-title-icon-div ${isOpen && "clicked"}`}
                  >
                    <div
                      className="mobile-title-progress-icon"
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      <i className="fa fa-bars-progress "></i>
                    </div>
                  </div>
                  {isOpen && (
                    <div className="dashboard-mobile-tooltip">
                      <Tooltip
                        placement="bottom"
                        className="gui-tooltip"
                        transition={false}
                        animation={false}
                      >
                        {state && (
                          <div className="progress-container">
                            <div
                              className={
                                state?.remainingCredits > 0
                                  ? "progress-container-text"
                                  : "progress-container-text-negative-credit"
                              }
                            >
                              {state?.remainingCredits <= 0 && (
                                <>
                                  <GuiTooltip
                                    tooltip="Overage charges will apply for any new messages."
                                    placement="top"
                                  >
                                    <i className="fa fa-exclamation-circle"></i>
                                  </GuiTooltip>{" "}
                                </>
                              )}
                              {state.remainingCredits} Texts/Voice Messages Left
                              This{" "}
                              {state.billingCycle === "Monthly"
                                ? "Month"
                                : "Year"}
                            </div>
                            <progress
                              value={state.remainingCredits}
                              max={state.totalCredits}
                              className={
                                state?.remainingCredits > 0
                                  ? "styled-progress-bar"
                                  : "styled-progress-bar negative-credits"
                              }
                            ></progress>
                          </div>
                        )}
                      </Tooltip>
                    </div>
                  )}
                </>
              )}
              <div className="message-header-buttons">
                {/* {canSendMessages && ( */}
                <MessageDropdown
                  from={DISCARD_ROUTES.messages}
                  userRole={currentUser?.userType}
                  // isAdminUser={isAdminUser}
                />
                {/* )} */}
                {/* {canSendMessages && ( */}
                <GuiButton
                  dataQa="emergency-button"
                  className="emergency-btn"
                  onClick={() => actions.alerts.showCreateAlert(true)}
                  style={{ marginLeft: 12 }}
                >
                  <i className="far fa-plus"></i>Emergency Message
                </GuiButton>
                {/* )} */}
              </div>
            </div>
          }
        >
          <div style={!isMobile ? { position: "relative" } : {}}>
            <Card className="messages-card">
              <>
                {isMobile ? (
                  <>
                    <div className="messages-search-header">
                      {loginUserType !== UserRole.Member && (
                        <>
                          <div className="modal-footer-hr-divider"></div>
                          <div className="messages-search-header-tabs">
                            <MessageTabs
                              tabs={tabs}
                              selectedTab={selectedTab}
                              onTabChange={handleTabChange}
                            />
                          </div>
                        </>
                      )}

                      <SliderSearchBox
                        createdUserList={state.createdUserList}
                        groupList={state.groupList}
                        applyFilter={applyFilter}
                        selectedFilter={state.selectedFilter}
                        onSearchChange={setSearch}
                        searching={state.loading}
                        searchValue={state.search}
                      />
                    </div>
                    <div className="filter-pill-container">
                      {state?.filterPills?.map((item, index) => {
                        const key = Object.keys(item)[0]; // Get the key name
                        const value = item[key]; // Get the value
                        return (
                          <GuiButton
                            className="filter-pill-btn"
                            key={index}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="filter-pill-btn-content">
                              <div className="filter-pill-btn-content-key">
                                {key}:
                              </div>
                              <div className="filter-pill-btn-content-value">
                                {value}
                              </div>

                              <i
                                className="fa fa-close"
                                onClick={() => handleIconClick(key)}
                              ></i>
                            </div>
                          </GuiButton>
                        );
                      })}
                    </div>
                    {isBulkActionTab && state.selectedMsg > 0 && (
                      <>
                        <div className="modal-footer-hr-divider"></div>
                        <div className="actions-btn-mobile">
                          <div className="actions-btn-mobile-selected">
                            {state.selectedMsg} Selected
                          </div>
                          <GuiButton
                            className="bulk-delete-btn"
                            disabled={!state.isDeleteEnabled}
                            onClick={(e) =>
                              updateState({
                                showDeleteModal: true,
                              })
                            }
                          >
                            <i className="fa fa-trash"></i> Delete
                          </GuiButton>
                        </div>
                        <div className="modal-footer-hr-divider"></div>
                      </>
                    )}
                    <div
                      className={`messages-grid${
                        isBulkActionTab && state.selectedMsg > 0
                          ? " bulk-bar-visible"
                          : ""
                      }`}
                    >
                      <Grid
                        itemTemplate={(g, index) => (
                          <div
                            className={`row${
                              checkboxState[`${g.groupId}_${g.id}`]
                                ? " selected-row"
                                : ""
                            }`}
                            key={`${g.groupId}_${g.id}_${index}`}
                          >
                            <div className="check">
                              <div className="check-row">
                                <div className="check-title">
                                  {isBulkActionTab && (
                                    <GuiCheckbox
                                      name={`${g.groupId}_${g.id}`}
                                      value={
                                        checkboxState[`${g.groupId}_${g.id}`] ||
                                        false
                                      }
                                      onChange={updateCheckboxState}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  )}
                                  <span className="initials">
                                    {getInitials(g.groupName) || (
                                      <i
                                        className="icon fas fa-paper-plane"
                                        style={{
                                          color: "#ccc",
                                          fontSize: "1.2em",
                                        }}
                                      ></i>
                                    )}
                                  </span>
                                </div>
                                <div className="check-body">
                                  <div
                                    className="check-body-name body-hover"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onMsgClick(g.id);
                                    }}
                                  >
                                    <div className="check-body-name-header">
                                      {g.isTempGroup && g.groupName
                                        ? (() => {
                                            const names = g.groupName
                                              .split(",")
                                              .map((n) => n.trim())
                                              .filter(Boolean);
                                            const shownNames = names
                                              .slice(0, 3)
                                              .join(", ");
                                            const remainingCount =
                                              names.length - 3;
                                            return (
                                              <span
                                                title={names.join(", ")}
                                                style={{
                                                  cursor:
                                                    remainingCount > 0
                                                      ? "pointer"
                                                      : "default",
                                                }}
                                                onClick={
                                                  remainingCount > 0
                                                    ? (e) => {
                                                        e.stopPropagation();
                                                        alert(
                                                          "Group Members:\n" +
                                                            names.join(", "),
                                                        );
                                                      }
                                                    : undefined
                                                }
                                              >
                                                {shownNames}
                                                {remainingCount > 0 && (
                                                  <span
                                                    style={{
                                                      marginLeft: 4,
                                                      color: "#888",
                                                    }}
                                                  >
                                                    {`+${remainingCount} more`}
                                                  </span>
                                                )}
                                              </span>
                                            );
                                          })()
                                        : g.groupName}

                                      {renderStatusBadge(g.status, true)}

                                      <GuiButton className="alert-type-btn-mobile">
                                        <span>
                                          <i
                                            className={alertIcon(g.alertType)}
                                          ></i>
                                          {alertTypeName(
                                            g.alertType,
                                            state.alertType,
                                          )}
                                        </span>
                                      </GuiButton>
                                    </div>
                                    <div
                                      className="check-body-actions"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                    >
                                      <span
                                        className={`check-body-date${
                                          g.status === 2
                                            ? "-scheduled"
                                            : g.status === 3
                                              ? "-draft"
                                              : "-default"
                                        }`}
                                      >
                                        {formattedDate(g.scheduled)}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="check-body-details-mobile">
                                    <div
                                      className="check-body-details-mobile-header body-hover"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onMsgClick(g.id);
                                      }}
                                    >
                                      <span className="msg-subject">
                                        {g.messageSubject}
                                      </span>
                                      {g.alertType === 1 ? (
                                        audioUrls[g.id] ? (
                                          <AudioPlayer
                                            src={audioUrls[g.id]}
                                            autoPlay={false}
                                          />
                                        ) : (
                                          <CircularProgress />
                                        )
                                      ) : (
                                        <span>
                                          {removeTags(
                                            formatDescription(
                                              g.messageBody,
                                              10,
                                            ),
                                          )}
                                          {" ..."}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                &nbsp;
                                {loginUserType !== UserRole.Member && (
                                  <div className="tridot">
                                    <i
                                      style={{
                                        cursor: "pointer",
                                        width: "10px",
                                      }}
                                      className="fa fa-ellipsis-vertical mobile-action-icon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        updateState({
                                          showActionsMenu: g.id,
                                        });
                                      }}
                                    ></i>
                                    <div className="actions">
                                      <Popover
                                        show={state.showActionsMenu === g.id}
                                        className="no-arrow anchor-right popover-menu actions-menu"
                                        onHide={() =>
                                          updateState("showActionsMenu", null)
                                        }
                                      >
                                        {getMenuOptionsForStatus(
                                          g.status,
                                          g,
                                        ).map((option) => (
                                          <div
                                            key={option}
                                            className="menu-item"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleTridotAction(option, g);
                                            }}
                                          >
                                            {option}
                                          </div>
                                        ))}
                                      </Popover>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        mobileItemHeight={65}
                        reset={state.gridReset}
                        pageSize={20}
                        onItemsNeeded={loadRows}
                        onPageChanged={onPageChanged}
                      ></Grid>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="messages-search-header">
                      <SliderSearchBox
                        createdUserList={state.createdUserList}
                        groupList={state.groupList}
                        applyFilter={applyFilter}
                        selectedFilter={state.selectedFilter}
                        onSearchChange={setSearch}
                        searching={state.isLoading}
                        searchValue={state.search}
                      />

                      {loginUserType !== UserRole.Member && (
                        <div className="messages-search-header-tabs">
                          <MessageTabs
                            tabs={tabs}
                            selectedTab={selectedTab}
                            onTabChange={handleTabChange}
                          />
                        </div>
                      )}
                    </div>
                    {/* <div> */}
                    <div className="filter-pill-container">
                      {state.filterPills.map((item, index) => {
                        const key = Object.keys(item)[0]; // Get the key name
                        const value = item[key]; // Get the value
                        return (
                          <GuiButton
                            className="filter-pill-btn"
                            key={index}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="filter-pill-btn-content">
                              <div className="filter-pill-btn-content-key">
                                {key}:
                              </div>
                              <div className="filter-pill-btn-content-value">
                                {value}
                              </div>

                              <i
                                className="fa fa-close"
                                onClick={() => handleIconClick(key)}
                              ></i>
                            </div>
                          </GuiButton>
                        );
                      })}
                    </div>
                    <div className="modal-footer-hr-divider"></div>
                    {isBulkActionTab && state.selectedMsg > 0 && (
                      <div className="messages-bulk-actions-bar">
                        <div className="messages-bulk-actions-bar-selected">
                          {state.selectedMsg} Selected
                        </div>
                        <div className="vr-divider">
                          <GuiButton
                            className="bulk-delete-btn"
                            disabled={!state.isDeleteEnabled}
                            onClick={(e) => {
                              e.stopPropagation();
                              updateState({
                                showDeleteModal: true,
                              });
                            }}
                          >
                            <i className="fa fa-trash"></i> Delete
                          </GuiButton>
                        </div>
                      </div>
                    )}
                    <div className="modal-footer-hr-divider"></div>
                    <div className="messages-grid">
                      <Grid
                        itemTemplate={(g) => (
                          <div className="row" key={g.id}>
                            <div className="check">
                              <div className="check-row">
                                <div className="check-title">
                                  {isBulkActionTab && (
                                    <GuiCheckbox
                                      name={`${g.groupId}_${g.id}`}
                                      key={g.id}
                                      value={
                                        checkboxState[`${g.groupId}_${g.id}`] ||
                                        false
                                      }
                                      onChange={updateCheckboxState}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  )}
                                  <span className="initials">
                                    {(() => {
                                      const cleanName = (g.groupName || "")
                                        .replace(/[^a-zA-Z0-9\s]/g, "")
                                        .replace(/\s+/g, " ")
                                        .trim();

                                      if (!cleanName) {
                                        return (
                                          <i
                                            className="icon fas fa-paper-plane"
                                            style={{
                                              color: "#ccc",
                                              fontSize: "1.2em",
                                            }}
                                          ></i>
                                        );
                                      }

                                      const initials = cleanName
                                        .split(" ")
                                        .filter(Boolean)
                                        .map((n) => n[0])
                                        .slice(0, 2)
                                        .join("")
                                        .toUpperCase();

                                      if (!initials) {
                                        return (
                                          <i
                                            className="icon fas fa-paper-plane"
                                            style={{
                                              color: "#ccc",
                                              fontSize: "1.2em",
                                            }}
                                          ></i>
                                        );
                                      }

                                      return initials;
                                    })()}
                                  </span>
                                </div>

                                <div className="check-body">
                                  <div
                                    className="body-hover"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onMsgClick(g.id);
                                    }}
                                  >
                                    <div className="check-body-name">
                                      {g.isTempGroup && g.groupName
                                        ? (() => {
                                            const names = g.groupName
                                              .split(",")
                                              .map((n) => n.trim())
                                              .filter(Boolean);
                                            const shownNames = names
                                              .slice(0, 3)
                                              .join(", ");
                                            const remainingCount =
                                              names.length - 3;
                                            return (
                                              <span
                                                title={names.join(", ")}
                                                style={{
                                                  cursor:
                                                    remainingCount > 0
                                                      ? "pointer"
                                                      : "default",
                                                }}
                                                onClick={
                                                  remainingCount > 0
                                                    ? (e) => {
                                                        e.stopPropagation();
                                                        alert(
                                                          "Group Members:\n" +
                                                            names.join(", "),
                                                        );
                                                      }
                                                    : undefined
                                                }
                                              >
                                                {shownNames}
                                                {remainingCount > 0 && (
                                                  <span
                                                    style={{
                                                      marginLeft: 4,
                                                      color: "#888",
                                                    }}
                                                  >
                                                    {`+${remainingCount} more`}
                                                  </span>
                                                )}
                                              </span>
                                            );
                                          })()
                                        : g.groupName}
                                    </div>
                                    <div
                                      className="check-body-details"
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      <div className="check-body-details-content">
                                        {renderStatusBadge(g.status)}

                                        <GuiButton className="alert-type-btn">
                                          <span>
                                            <i
                                              className={alertIcon(g.alertType)}
                                            ></i>
                                            {alertTypeName(
                                              g.alertType,
                                              state.alertType,
                                            )}
                                          </span>
                                        </GuiButton>
                                        <span className="msg-subject">
                                          {g.messageSubject}
                                        </span>
                                        {g.alertType === 1 ? (
                                          audioUrls[g.id] ? (
                                            <AudioPlayer
                                              src={audioUrls[g.id]}
                                              autoPlay={false}
                                            />
                                          ) : (
                                            <CircularProgress />
                                          )
                                        ) : (
                                          <span>
                                            {removeTags(
                                              formatDescription(
                                                g.messageBody,
                                                10,
                                              ),
                                            )}
                                            {" ..."}
                                          </span>
                                        )}
                                      </div>
                                      <div
                                        className="check-body-actions"
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <span
                                          className={`check-body-date${
                                            g.status === 2
                                              ? "-scheduled"
                                              : g.status === 3
                                                ? "-draft"
                                                : "-default"
                                          }`}
                                        >
                                          {formattedDate(g.scheduled)}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {loginUserType !== UserRole.Member && (
                                  <div className="tridot">
                                    <div>
                                      <i
                                        style={{
                                          cursor: "pointer",
                                          width: "10px",
                                        }}
                                        className="fa fa-ellipsis-vertical mobile-action-icon"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          updateState({
                                            showActionsMenu: g.id,
                                          });
                                        }}
                                      ></i>
                                    </div>
                                    <div className="actions">
                                      <Popover
                                        show={state.showActionsMenu === g.id}
                                        className="no-arrow anchor-right popover-menu actions-menu"
                                        onHide={() =>
                                          updateState("showActionsMenu", null)
                                        }
                                      >
                                        {getMenuOptionsForStatus(
                                          g.status,
                                          g,
                                        ).map((option) => (
                                          <div
                                            key={option}
                                            className="menu-item"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleTridotAction(option, g);
                                            }}
                                          >
                                            {option}
                                          </div>
                                        ))}
                                      </Popover>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        mobileItemHeight={65}
                        reset={state.gridReset}
                        pageSize={20}
                        onItemsNeeded={loadRows}
                        onPageChanged={onPageChanged}
                        pageName="messages"
                      ></Grid>
                    </div>
                  </>
                )}
              </>
            </Card>
            {state?.isLoading && (
              <div className="messages-loader">
                <CircularProgress />
              </div>
            )}
          </div>
        </PageLayout>

        {!useIsDesktop() && <BottomNavBar />}

        {state.showDeleteModal && (
          <Modal className="modal bulk-delete-modal">
            <div className="bulk-delete-modal-header">
              <span>Delete Message(s)?</span>
              <div
                onClick={() => {
                  updateState({ showDeleteModal: false });
                }}
              >
                <i className="fa fa-close close-primary-icon cursor-pointer"></i>
              </div>
            </div>
            <div className="modal-footer-hr-divider"></div>
            <div className="bulk-delete-modal-content">
              <span>
                This action cannot be undone. Please note only Scheduled and
                Draft messages can be deleted. Are you sure you want to delete
                these {state?.selectedMsg} message(s)?
              </span>
            </div>
            <div className="bulk-delete-modal-footer">
              <GuiButton
                className="btn-outline"
                disabled={state?.isLoading}
                onClick={() =>
                  updateState({
                    showDeleteModal: false,
                    singleEntryDelete: false,
                    singleEntryId: [],
                  })
                }
              >
                Cancel
              </GuiButton>
              <GuiButton
                className="warning"
                disabled={state?.isLoading}
                onClick={handleDelete}
              >
                {`Delete ${state.selectedMsg} Message(s)`}
              </GuiButton>
            </div>
          </Modal>
        )}
      </div>
    </>
  );
}
